import { useState } from "react";
import { FaDownload } from "react-icons/fa";

async function pdfCompatibleImage(source) {
  if (!source) return "";
  if (/\.(?:png|jpe?g)(?:\?|$)/i.test(source) || source.startsWith("data:image/png") || source.startsWith("data:image/jpeg")) {
    return source;
  }

  return new Promise((resolve) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => {
      try {
        const maxDimension = 1800;
        const scale = Math.min(1, maxDimension / Math.max(image.naturalWidth, image.naturalHeight));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(image.naturalWidth * scale);
        canvas.height = Math.round(image.naturalHeight * scale);
        const context = canvas.getContext("2d");
        if (!context) return resolve("");
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", .9));
      } catch (_error) {
        resolve("");
      }
    };
    image.onerror = () => resolve("");
    image.src = source;
  });
}

export default function MediaKitDownloadButton({ content, stats, summary }) {
  const [state, setState] = useState({ loading: false, error: "" });

  async function download() {
    setState({ loading: true, error: "" });
    try {
      const [{ pdf }, { default: MediaKitPdf }] = await Promise.all([
        import("@react-pdf/renderer"),
        import("./MediaKitPdf"),
      ]);
      const pdfHeroImageUrl = await pdfCompatibleImage(content.heroImageUrl);
      const blob = await pdf(<MediaKitPdf content={{ ...content, pdfHeroImageUrl }} stats={stats} summary={summary} />).toBlob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = `Ken-and-Bryn-Media-Kit-${new Date().toISOString().slice(0, 10)}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
      setState({ loading: false, error: "" });
    } catch (error) {
      console.error(error);
      setState({ loading: false, error: "The PDF could not be generated. Please try again." });
    }
  }

  return (
    <div className="media-kit-download-control">
      <button type="button" className="media-kit-primary-action" onClick={download} disabled={state.loading}>
        <FaDownload aria-hidden="true" /> {state.loading ? "Preparing PDF…" : "Download media kit"}
      </button>
      {state.error && <span role="alert">{state.error}</span>}
    </div>
  );
}
